module.exports = __webpack_public_path__ + "img/confirmation-loading.2affb4f3.png";